<template>
    <div style="box-sizing: border-box;padding: 20px 0;">
        <div class="bk">
            <div class="flx alc cursor" style="height: 100%;" @click="bobk">
                <i class="el-icon-arrow-left" style="margin-right: 8px;"></i> 返回
            </div>
        </div>
        <div class="fs">
            <div class="ptitle">
                报名信息
            </div>
            <div class="item flx alc">
                <div class="itemLeft">
                    姓名
                </div>
                <div class="itemRight" v-text="info.name">
                    
                </div>
            </div>
            
            <div class="item flx alc">
                <div class="itemLeft">
                    手机号
                </div>
                <div class="itemRight" v-text="info.tel">
                    
                </div>
            </div>
            
            <div class="item flx alc">
                <div class="itemLeft">
                    邮箱
                </div>
                <div class="itemRight" v-text="info.email">
                    
                </div>
            </div>
            
            <div class="item flx alc">
                <div class="itemLeft">
                    企业名称
                </div>
                <div class="itemRight" v-text="info.company_name">
                    
                </div>
            </div>
            
            <div class="item flx alc">
                <div class="itemLeft">
                    岗位职务
                </div>
                <div class="itemRight" v-text="info.position_name">
                    
                </div>
            </div>
            
            <div class="item flx alc">
                <div class="itemLeft">
                    行业类型
                </div>
                <div class="itemRight" v-text="info.industry_name">
                    
                </div>
            </div>
            
            <div class="item flx alc">
                <div class="itemLeft">
                    所在地区
                </div>
                <div class="itemRight" v-text="info.address">
                    
                </div>
            </div>
            
            <div class="item flx alc">
                <div class="itemLeft">
                    需求
                </div>
                <div class="itemRight" v-text="info.demand">
                    
                </div>
            </div>
            
            <div class="item flx">
                <div class="itemLeft" style="position: relative;top: 18px;">
                    身份验证
                </div>
                <div class="chep">
                    <img :src="$img(info.id_img)" alt="" />
                </div>
            </div>
            
            <div class="item flx alc">
                <div class="itemLeft">
                    推荐人姓名
                </div>
                <div class="itemRight" v-text="info.promoter">
                    
                </div>
            </div>
            
            <div class="item flx alc">
                <div class="itemLeft">
                    微信
                </div>
                <div class="itemRight" v-text="info.wx_number">
                    
                </div>
            </div>
            
            <div class="item flx alc">
                <div class="itemLeft">
                    QQ
                </div>
                <div class="itemRight" v-text="info.qq">
                    
                </div>
            </div>
            
            <div class="item flx alc">
                <div class="itemLeft">
                    学历
                </div>
                <div class="itemRight" v-text="info.ed">
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        checkpeople
    } from "@/api/index.js"
    export default {
        data() {
            return {
                totals: 0,
                id: "",
                info:{}
            }
        },
        created() {
            this.id = this.$route.query.id
            this.getList()
        },
        methods: {
            getList() {
                let that = this
                let data = {}
                data.id = that.id
                checkpeople(data).then((res) => {
                    console.log("info",res)
                    if (res.code == 1) {
                       that.info = res.data
                       that.$nextTick(() => {
                           window.scrollTo(0, 0)
                       })
                    }
                })
            },
            handleCurrentChange(e) {
                console.log(e)
            },
            bobk() {
                this.$router.go(-1)
            },
            handleClick(e) {
                console.log(e)
            },
            toggleSelection(rows) {
                if (rows) {
                    rows.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row);
                    });
                } else {
                    this.$refs.multipleTable.clearSelection();
                }
            },
            handleSelectionChange(val) {
                console.log(val)
                this.multipleSelection = val;
            }
        }
    }
</script>

<style scoped>
    .chep{
        width: 516px;
        height: 252px;
    }
    .chep img{
        width: 100%;
        height: 100%;
        border-radius: 4px;
        object-fit: contain;
    }
    .item{
        margin-bottom: 36px;
    }
    .itemLeft{
        width: 215px;
        text-align: right;
        margin-right: 16px;
        font-size: 14px;
        color: #48576A;
    }
    .itemRight{
        width: 516px;
        height: 34px;
        border-radius: 4px;
        border: 1px solid #D9D9D9;
        text-align: left;
        line-height: 34px;
        font-size: 14px;
        color: #141933;
        box-sizing: border-box;
        padding: 0 16px;
    }
    .ptitle{
        font-weight: 600;
        font-size: 18px;
        margin-bottom: 30px;
        text-align: left;
    }
    .fs {
        width: 1460px;
        background-color: #fff;
        margin: 0 auto;
        box-sizing: border-box;
        padding: 40px 30px;
        border-radius: 10px;
    }

    .bk {
        width: 1460px;
        height: 68px;
        background: #FFFFFF;
        box-sizing: border-box;
        padding: 0 30px;
        margin: 0 auto 20px;
        font-size: 14px;
        color: #000000;
    }
</style>